export function isLastAdminError(detail: unknown): boolean {
  if (typeof detail !== 'string') return false;

  return /last\s+admin/i.test(detail);
}

export function isRequestCanceled(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    ('name' in error || 'code' in error) &&
    ((error as { name?: string }).name === 'CanceledError' ||
      (error as { code?: string }).code === 'ERR_CANCELED')
  );
}

type ErrorWithDetail = {
  response?: {
    data?: {
      detail?: unknown;
    };
  };
  message?: unknown;
};

export function extractErrorMessage(error: unknown, fallback: string): string {
  const detail = (error as ErrorWithDetail)?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;

  const message = (error as ErrorWithDetail)?.message;
  if (typeof message === 'string' && message.trim()) return message;

  return fallback;
}
